import { Injectable } from '@angular/core';
import { fabric } from 'fabric';

@Injectable({ providedIn: 'root' })
export class FabricService {
  private canvases = new Map<string, fabric.Canvas>();

  createCanvas(element: HTMLCanvasElement, options: fabric.ICanvasOptions = {}): fabric.Canvas {
    const canvas = new fabric.Canvas(element, {
      isDrawingMode: false,
      selection: false,
      ...options
    });
    this.canvases.set(element.id, canvas);
    return canvas;
  }

  loadSignature(canvas: fabric.Canvas, data: any): void {
    if (!data) return;

    canvas.loadFromJSON(data, () => {
      canvas.renderAll();
      canvas.forEachObject(obj => {
        obj.selectable = false;
        obj.evented = false;
      });
    });
  }

  destroyCanvas(canvas: fabric.Canvas): void {
    canvas.dispose();
    this.canvases.delete(canvas.getElement().id);
  }

  getCanvas(elementId: string): fabric.Canvas | undefined {
    return this.canvases.get(elementId);
  }
}
